var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.936,
    height: 30.4,
    viewBox: "0 0 28.936 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49658",
    "data-name": "Group 49658",
    transform: "translate(-4342.5 -208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93393",
    "data-name": "Path 93393",
    d: "M30.225,1.2H5.743A2.233,2.233,0,0,0,3.5,3.443V22.411a2.233,2.233,0,0,0,2.243,2.243h8.223a.779.779,0,1,0,0-1.557H5.743a.691.691,0,0,1-.685-.685V8.208H30.879V22.38a.691.691,0,0,1-.685.685h-8.13a.779.779,0,1,0,0,1.557h8.13a2.233,2.233,0,0,0,2.243-2.243V3.411A2.22,2.22,0,0,0,30.225,1.2ZM5.089,6.651V3.411a.691.691,0,0,1,.685-.685H30.225a.691.691,0,0,1,.685.685V6.651ZM11.131,4.72a.937.937,0,0,1-.934.934.958.958,0,0,1-.934-.934.934.934,0,1,1,1.869,0Zm3.115,0a.934.934,0,1,1-.934-.934A.917.917,0,0,1,14.246,4.72Zm-6.23,0a.937.937,0,0,1-.934.934.958.958,0,0,1-.934-.934.934.934,0,1,1,1.869,0Zm6.23,15.107a.753.753,0,0,1,0-1.09l3.177-3.177a.753.753,0,0,1,1.09,0l3.208,3.177a.782.782,0,0,1-1.121,1.09l-1.838-1.838V30.821a.779.779,0,1,1-1.557,0V17.989l-1.838,1.838A.79.79,0,0,1,14.246,19.826Zm10.59-6.136h-13.7a.779.779,0,1,1,0-1.557h13.7a.779.779,0,1,1,0,1.557Z",
    transform: "translate(4339 206.8)",
    fill: "#0c66e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkImport);
export default __webpack_public_path__ + "static/media/bulk-import.d0648ca8af2adee8545881d790b69984.svg";
export { ForwardRef as ReactComponent };